// extracted by mini-css-extract-plugin
module.exports = {"container":"ChatTrigger_container__m9RIp","icon":"ChatTrigger_icon__ybfBp"};